import Vue from 'vue'
import { Toast, Dialog } from 'cube-ui'
Vue.use(Toast)
Vue.use(Dialog)

export interface bizError {
  errmsg?: string
  errno?: string
  handled?: boolean
  data?: Record<string, unknown>
}

let toastInstance: Toast

function showToast(txt = '请稍后再试', type = 'warn', options = {}): void {
  toastInstance = Toast.$create({
    type,
    txt,
    time: 2000,
    ...options
  })
  toastInstance.show()
}

function hideToast(): void {
  toastInstance && toastInstance.hide()
}

function showLoading(txt = '加载中...'): void {
  showToast(txt, 'loading', { time: 0 })
}

function hideLoading(): void {
  hideToast()
}

function commonErrAlert(err: bizError): void {
  if (err != null) {
    if (err.handled) {
      hideToast()
    } else {
      Dialog.$create({
        type: 'alert',
        content: err.errmsg || '请稍后再试',
        icon: 'cubeic-alert',
        confirmBtn: {
          text: '我知道了',
          active: true,
          disabled: false,
          href: 'javascript:;'
        }
      }).show()
    }
  }
}

function commonErrToast(err: bizError | unknown): void {
  if (err != null) {
    if ((err as bizError).handled) {
      hideToast()
    } else {
      showToast((err as bizError).errmsg || '请稍候再试')
    }
  } else {
    showToast('请稍候再试')
  }
}

const ToastClass = {
  showToast,
  hideToast,
  showLoading,
  hideLoading,
  commonErrAlert,
  commonErrToast
}

export default ToastClass

export {
  showToast,
  hideToast,
  showLoading,
  hideLoading,
  commonErrAlert,
  commonErrToast
}
